import libPhoneNumber from 'google-libphonenumber'

const phoneUtil = libPhoneNumber.PhoneNumberUtil.getInstance()

export function validatePhoneNumber (phoneNumber) {
  let valid = false
  try {
    valid = phoneUtil.isValidNumberForRegion(phoneUtil.parse(phoneNumber, 'AU'), 'AU')
  } catch (_) {}
  return valid
}
